import i18n from "@/i18n";
import Api from "@/services/api";
import { Solution, SolutionsFilterDtoIn, SolutionInfo, AddContractDto, CopySolution } from "@/services/solutions/types";
import { AclMember } from "../security/types";
import moment from "moment";

export async function getSolutions(): Promise<Array<Solution>> {
    return new Promise((resolve, reject) => {
        Api.get("/solution").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getSolution(id: string): Promise<Solution> {
    return new Promise((resolve, reject) => {
        Api.get(`/solution/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function createSolution(board: Solution): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/solution", board).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function updateSolution(board: Solution): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/solution", board).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function deleteSolution(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/solution/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getFilteredSolutions(model: SolutionsFilterDtoIn): Promise<Solution[]> {
    return new Promise((resolve, reject) => {
        Api.post("/solution/filter", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function GetSolutionInfo(id: string): Promise<SolutionInfo> {
    return new Promise((resolve, reject) => {
        Api.get(`/solution/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/solution/delete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAcl(id: string): Promise<AclMember[]> {
    return new Promise((resolve, reject) => {
        Api.get(`/acl/solution/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelFilterSolutions(): Promise<Array<Solution>> {
    return new Promise((resolve, reject) => {
        Api.get("/solution/channelfiltersolutions").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function addContract(model: AddContractDto[]): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/solution/addcontract", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function deleteContract(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/solution/deletecontract/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function setSolutionType(solutions: string[], licenceType: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post(`/solution/setSolutionType`, { solutionIds: solutions, licenceType: licenceType }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export function copySolution(solution: CopySolution): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post("/solution/copy/", solution).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function setMassForceOn(dateTime: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/solution/forceOn/`, { dateTime: dateTime }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getSolutionTypes(): Promise<string[]> {
    return new Promise((resolve, reject) => {
        Api.get("/solution/types").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getSolutionsForContent(id: string): Promise<Array<Solution>> {
    return new Promise((resolve, reject) => {
        Api.get(`/solution/GetSolutionsForContent/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function GetSolutionStatus(solution: Solution) {
    if (!solution.templateId) return i18n.t("solution.noDesign");
    if (!solution.playerId) return i18n.t("solution.noPlayer");
    if (solution.status) return i18n.t("common.online");
    let response = i18n.t("common.offline");
    if (solution.lastActiveDate) response += ` ${i18n.t("solution.since")} ${moment.utc(solution.lastActiveDate).local().format("dddd")} <br> ${i18n.d(new Date(solution.lastActiveDate), "short")} ${moment.utc(solution.lastActiveDate).local().format("HH:mm")}`;
    return response;
}
